/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
  type WritableSignerAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { CPMM_MIGRATOR_PROGRAM_ADDRESS } from '../programs';

export const CREATE_SPOT_POOL_DISCRIMINATOR = new Uint8Array([
  13, 137, 16, 26, 40, 36, 110, 26,
]);

export function getCreateSpotPoolDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    CREATE_SPOT_POOL_DISCRIMINATOR,
  );
}

export type CreateSpotPoolInstruction<
  TProgram extends string = typeof CPMM_MIGRATOR_PROGRAM_ADDRESS,
  TAccountCpmmConfig extends string | AccountMeta<string> = string,
  TAccountPayer extends string | AccountMeta<string> = string,
  TAccountLiquidityOwner extends string | AccountMeta<string> = string,
  TAccountToken0Mint extends string | AccountMeta<string> = string,
  TAccountToken1Mint extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountPoolAuthority extends string | AccountMeta<string> = string,
  TAccountPoolVault0 extends string | AccountMeta<string> = string,
  TAccountPoolVault1 extends string | AccountMeta<string> = string,
  TAccountProtocolFeeOwner extends string | AccountMeta<string> = string,
  TAccountProtocolFeePosition extends string | AccountMeta<string> = string,
  TAccountPosition extends string | AccountMeta<string> = string,
  TAccountUser0 extends string | AccountMeta<string> = string,
  TAccountUser1 extends string | AccountMeta<string> = string,
  TAccountCpmmProgram extends string | AccountMeta<string> =
    '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ',
  TAccountMigrationAuthority extends string | AccountMeta<string> = string,
  TAccountToken0Program extends string | AccountMeta<string> = string,
  TAccountToken1Program extends string | AccountMeta<string> = string,
  TAccountSystemProgram extends string | AccountMeta<string> =
    '11111111111111111111111111111111',
  TAccountRent extends string | AccountMeta<string> =
    'SysvarRent111111111111111111111111111111111',
  TAccountHookProgram extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountCpmmConfig extends string
        ? ReadonlyAccount<TAccountCpmmConfig>
        : TAccountCpmmConfig,
      TAccountPayer extends string
        ? WritableSignerAccount<TAccountPayer> &
            AccountSignerMeta<TAccountPayer>
        : TAccountPayer,
      TAccountLiquidityOwner extends string
        ? ReadonlySignerAccount<TAccountLiquidityOwner> &
            AccountSignerMeta<TAccountLiquidityOwner>
        : TAccountLiquidityOwner,
      TAccountToken0Mint extends string
        ? ReadonlyAccount<TAccountToken0Mint>
        : TAccountToken0Mint,
      TAccountToken1Mint extends string
        ? ReadonlyAccount<TAccountToken1Mint>
        : TAccountToken1Mint,
      TAccountPool extends string
        ? WritableAccount<TAccountPool>
        : TAccountPool,
      TAccountPoolAuthority extends string
        ? ReadonlyAccount<TAccountPoolAuthority>
        : TAccountPoolAuthority,
      TAccountPoolVault0 extends string
        ? WritableAccount<TAccountPoolVault0>
        : TAccountPoolVault0,
      TAccountPoolVault1 extends string
        ? WritableAccount<TAccountPoolVault1>
        : TAccountPoolVault1,
      TAccountProtocolFeeOwner extends string
        ? ReadonlyAccount<TAccountProtocolFeeOwner>
        : TAccountProtocolFeeOwner,
      TAccountProtocolFeePosition extends string
        ? WritableAccount<TAccountProtocolFeePosition>
        : TAccountProtocolFeePosition,
      TAccountPosition extends string
        ? WritableAccount<TAccountPosition>
        : TAccountPosition,
      TAccountUser0 extends string
        ? WritableAccount<TAccountUser0>
        : TAccountUser0,
      TAccountUser1 extends string
        ? WritableAccount<TAccountUser1>
        : TAccountUser1,
      TAccountCpmmProgram extends string
        ? ReadonlyAccount<TAccountCpmmProgram>
        : TAccountCpmmProgram,
      TAccountMigrationAuthority extends string
        ? ReadonlyAccount<TAccountMigrationAuthority>
        : TAccountMigrationAuthority,
      TAccountToken0Program extends string
        ? ReadonlyAccount<TAccountToken0Program>
        : TAccountToken0Program,
      TAccountToken1Program extends string
        ? ReadonlyAccount<TAccountToken1Program>
        : TAccountToken1Program,
      TAccountSystemProgram extends string
        ? ReadonlyAccount<TAccountSystemProgram>
        : TAccountSystemProgram,
      TAccountRent extends string
        ? ReadonlyAccount<TAccountRent>
        : TAccountRent,
      TAccountHookProgram extends string
        ? ReadonlyAccount<TAccountHookProgram>
        : TAccountHookProgram,
      ...TRemainingAccounts,
    ]
  >;

export type CreateSpotPoolInstructionData = {
  discriminator: ReadonlyUint8Array;
  swapFeeBps: number;
  positionId: bigint;
  amount0Max: bigint;
  amount1Max: bigint;
  minSharesOut: bigint;
  /**
   * `Pubkey::default()` creates a hookless spot pool (unchanged legacy path).
   * Any other value creates a hooked spot pool whose address commits to the
   * hook program and flags.
   */
  hookProgram: Address;
  hookFlags: number;
};

export type CreateSpotPoolInstructionDataArgs = {
  swapFeeBps: number;
  positionId: number | bigint;
  amount0Max: number | bigint;
  amount1Max: number | bigint;
  minSharesOut: number | bigint;
  /**
   * `Pubkey::default()` creates a hookless spot pool (unchanged legacy path).
   * Any other value creates a hooked spot pool whose address commits to the
   * hook program and flags.
   */
  hookProgram: Address;
  hookFlags: number;
};

export function getCreateSpotPoolInstructionDataEncoder(): FixedSizeEncoder<CreateSpotPoolInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([
      ['discriminator', fixEncoderSize(getBytesEncoder(), 8)],
      ['swapFeeBps', getU16Encoder()],
      ['positionId', getU64Encoder()],
      ['amount0Max', getU64Encoder()],
      ['amount1Max', getU64Encoder()],
      ['minSharesOut', getU128Encoder()],
      ['hookProgram', getAddressEncoder()],
      ['hookFlags', getU32Encoder()],
    ]),
    (value) => ({ ...value, discriminator: CREATE_SPOT_POOL_DISCRIMINATOR }),
  );
}

export function getCreateSpotPoolInstructionDataDecoder(): FixedSizeDecoder<CreateSpotPoolInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
    ['swapFeeBps', getU16Decoder()],
    ['positionId', getU64Decoder()],
    ['amount0Max', getU64Decoder()],
    ['amount1Max', getU64Decoder()],
    ['minSharesOut', getU128Decoder()],
    ['hookProgram', getAddressDecoder()],
    ['hookFlags', getU32Decoder()],
  ]);
}

export function getCreateSpotPoolInstructionDataCodec(): FixedSizeCodec<
  CreateSpotPoolInstructionDataArgs,
  CreateSpotPoolInstructionData
> {
  return combineCodec(
    getCreateSpotPoolInstructionDataEncoder(),
    getCreateSpotPoolInstructionDataDecoder(),
  );
}

export type CreateSpotPoolAsyncInput<
  TAccountCpmmConfig extends string = string,
  TAccountPayer extends string = string,
  TAccountLiquidityOwner extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountPool extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountProtocolFeeOwner extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountPosition extends string = string,
  TAccountUser0 extends string = string,
  TAccountUser1 extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountMigrationAuthority extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountHookProgram extends string = string,
> = {
  cpmmConfig: Address<TAccountCpmmConfig>;
  payer: TransactionSigner<TAccountPayer>;
  liquidityOwner: TransactionSigner<TAccountLiquidityOwner>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  pool: Address<TAccountPool>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  protocolFeeOwner: Address<TAccountProtocolFeeOwner>;
  protocolFeePosition: Address<TAccountProtocolFeePosition>;
  position: Address<TAccountPosition>;
  user0: Address<TAccountUser0>;
  user1: Address<TAccountUser1>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  migrationAuthority?: Address<TAccountMigrationAuthority>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /**
   * Omit it entirely for a hookless pool. When present it must equal
   * `args.hook_program`; CPMM additionally requires it to be executable.
   */
  hookProgram?: Address<TAccountHookProgram>;
  swapFeeBps: CreateSpotPoolInstructionDataArgs['swapFeeBps'];
  positionId: CreateSpotPoolInstructionDataArgs['positionId'];
  amount0Max: CreateSpotPoolInstructionDataArgs['amount0Max'];
  amount1Max: CreateSpotPoolInstructionDataArgs['amount1Max'];
  minSharesOut: CreateSpotPoolInstructionDataArgs['minSharesOut'];
  hookProgramArg: CreateSpotPoolInstructionDataArgs['hookProgram'];
  hookFlags: CreateSpotPoolInstructionDataArgs['hookFlags'];
};

export async function getCreateSpotPoolInstructionAsync<
  TAccountCpmmConfig extends string,
  TAccountPayer extends string,
  TAccountLiquidityOwner extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountPool extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountProtocolFeeOwner extends string,
  TAccountProtocolFeePosition extends string,
  TAccountPosition extends string,
  TAccountUser0 extends string,
  TAccountUser1 extends string,
  TAccountCpmmProgram extends string,
  TAccountMigrationAuthority extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountHookProgram extends string,
  TProgramAddress extends Address = typeof CPMM_MIGRATOR_PROGRAM_ADDRESS,
>(
  input: CreateSpotPoolAsyncInput<
    TAccountCpmmConfig,
    TAccountPayer,
    TAccountLiquidityOwner,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeeOwner,
    TAccountProtocolFeePosition,
    TAccountPosition,
    TAccountUser0,
    TAccountUser1,
    TAccountCpmmProgram,
    TAccountMigrationAuthority,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountHookProgram
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  CreateSpotPoolInstruction<
    TProgramAddress,
    TAccountCpmmConfig,
    TAccountPayer,
    TAccountLiquidityOwner,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeeOwner,
    TAccountProtocolFeePosition,
    TAccountPosition,
    TAccountUser0,
    TAccountUser1,
    TAccountCpmmProgram,
    TAccountMigrationAuthority,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountHookProgram
  >
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? CPMM_MIGRATOR_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    cpmmConfig: { value: input.cpmmConfig ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    liquidityOwner: { value: input.liquidityOwner ?? null, isWritable: false },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    protocolFeeOwner: {
      value: input.protocolFeeOwner ?? null,
      isWritable: false,
    },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    position: { value: input.position ?? null, isWritable: true },
    user0: { value: input.user0 ?? null, isWritable: true },
    user1: { value: input.user1 ?? null, isWritable: true },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    migrationAuthority: {
      value: input.migrationAuthority ?? null,
      isWritable: false,
    },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input, hookProgram: input.hookProgramArg };

  // Resolve default values.
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }
  if (!accounts.migrationAuthority.value) {
    accounts.migrationAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            109, 105, 103, 114, 97, 116, 105, 111, 110, 95, 97, 117, 116, 104,
            111, 114, 105, 116, 121,
          ]),
        ),
      ],
    });
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('cpmmConfig', accounts.cpmmConfig),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('liquidityOwner', accounts.liquidityOwner),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('protocolFeeOwner', accounts.protocolFeeOwner),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('position', accounts.position),
      getAccountMeta('user0', accounts.user0),
      getAccountMeta('user1', accounts.user1),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('migrationAuthority', accounts.migrationAuthority),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('hookProgram', accounts.hookProgram),
    ],
    data: getCreateSpotPoolInstructionDataEncoder().encode(
      args as CreateSpotPoolInstructionDataArgs,
    ),
    programAddress,
  } as CreateSpotPoolInstruction<
    TProgramAddress,
    TAccountCpmmConfig,
    TAccountPayer,
    TAccountLiquidityOwner,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeeOwner,
    TAccountProtocolFeePosition,
    TAccountPosition,
    TAccountUser0,
    TAccountUser1,
    TAccountCpmmProgram,
    TAccountMigrationAuthority,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountHookProgram
  >);
}

export type CreateSpotPoolInput<
  TAccountCpmmConfig extends string = string,
  TAccountPayer extends string = string,
  TAccountLiquidityOwner extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountPool extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountProtocolFeeOwner extends string = string,
  TAccountProtocolFeePosition extends string = string,
  TAccountPosition extends string = string,
  TAccountUser0 extends string = string,
  TAccountUser1 extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountMigrationAuthority extends string = string,
  TAccountToken0Program extends string = string,
  TAccountToken1Program extends string = string,
  TAccountSystemProgram extends string = string,
  TAccountRent extends string = string,
  TAccountHookProgram extends string = string,
> = {
  cpmmConfig: Address<TAccountCpmmConfig>;
  payer: TransactionSigner<TAccountPayer>;
  liquidityOwner: TransactionSigner<TAccountLiquidityOwner>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  pool: Address<TAccountPool>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  protocolFeeOwner: Address<TAccountProtocolFeeOwner>;
  protocolFeePosition: Address<TAccountProtocolFeePosition>;
  position: Address<TAccountPosition>;
  user0: Address<TAccountUser0>;
  user1: Address<TAccountUser1>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  migrationAuthority: Address<TAccountMigrationAuthority>;
  token0Program: Address<TAccountToken0Program>;
  token1Program: Address<TAccountToken1Program>;
  systemProgram?: Address<TAccountSystemProgram>;
  rent?: Address<TAccountRent>;
  /**
   * Omit it entirely for a hookless pool. When present it must equal
   * `args.hook_program`; CPMM additionally requires it to be executable.
   */
  hookProgram?: Address<TAccountHookProgram>;
  swapFeeBps: CreateSpotPoolInstructionDataArgs['swapFeeBps'];
  positionId: CreateSpotPoolInstructionDataArgs['positionId'];
  amount0Max: CreateSpotPoolInstructionDataArgs['amount0Max'];
  amount1Max: CreateSpotPoolInstructionDataArgs['amount1Max'];
  minSharesOut: CreateSpotPoolInstructionDataArgs['minSharesOut'];
  hookProgramArg: CreateSpotPoolInstructionDataArgs['hookProgram'];
  hookFlags: CreateSpotPoolInstructionDataArgs['hookFlags'];
};

export function getCreateSpotPoolInstruction<
  TAccountCpmmConfig extends string,
  TAccountPayer extends string,
  TAccountLiquidityOwner extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountPool extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountProtocolFeeOwner extends string,
  TAccountProtocolFeePosition extends string,
  TAccountPosition extends string,
  TAccountUser0 extends string,
  TAccountUser1 extends string,
  TAccountCpmmProgram extends string,
  TAccountMigrationAuthority extends string,
  TAccountToken0Program extends string,
  TAccountToken1Program extends string,
  TAccountSystemProgram extends string,
  TAccountRent extends string,
  TAccountHookProgram extends string,
  TProgramAddress extends Address = typeof CPMM_MIGRATOR_PROGRAM_ADDRESS,
>(
  input: CreateSpotPoolInput<
    TAccountCpmmConfig,
    TAccountPayer,
    TAccountLiquidityOwner,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeeOwner,
    TAccountProtocolFeePosition,
    TAccountPosition,
    TAccountUser0,
    TAccountUser1,
    TAccountCpmmProgram,
    TAccountMigrationAuthority,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountHookProgram
  >,
  config?: { programAddress?: TProgramAddress },
): CreateSpotPoolInstruction<
  TProgramAddress,
  TAccountCpmmConfig,
  TAccountPayer,
  TAccountLiquidityOwner,
  TAccountToken0Mint,
  TAccountToken1Mint,
  TAccountPool,
  TAccountPoolAuthority,
  TAccountPoolVault0,
  TAccountPoolVault1,
  TAccountProtocolFeeOwner,
  TAccountProtocolFeePosition,
  TAccountPosition,
  TAccountUser0,
  TAccountUser1,
  TAccountCpmmProgram,
  TAccountMigrationAuthority,
  TAccountToken0Program,
  TAccountToken1Program,
  TAccountSystemProgram,
  TAccountRent,
  TAccountHookProgram
> {
  // Program address.
  const programAddress =
    config?.programAddress ?? CPMM_MIGRATOR_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    cpmmConfig: { value: input.cpmmConfig ?? null, isWritable: false },
    payer: { value: input.payer ?? null, isWritable: true },
    liquidityOwner: { value: input.liquidityOwner ?? null, isWritable: false },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: true },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    protocolFeeOwner: {
      value: input.protocolFeeOwner ?? null,
      isWritable: false,
    },
    protocolFeePosition: {
      value: input.protocolFeePosition ?? null,
      isWritable: true,
    },
    position: { value: input.position ?? null, isWritable: true },
    user0: { value: input.user0 ?? null, isWritable: true },
    user1: { value: input.user1 ?? null, isWritable: true },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    migrationAuthority: {
      value: input.migrationAuthority ?? null,
      isWritable: false,
    },
    token0Program: { value: input.token0Program ?? null, isWritable: false },
    token1Program: { value: input.token1Program ?? null, isWritable: false },
    systemProgram: { value: input.systemProgram ?? null, isWritable: false },
    rent: { value: input.rent ?? null, isWritable: false },
    hookProgram: { value: input.hookProgram ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Original args.
  const args = { ...input, hookProgram: input.hookProgramArg };

  // Resolve default values.
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }
  if (!accounts.systemProgram.value) {
    accounts.systemProgram.value =
      '11111111111111111111111111111111' as Address<'11111111111111111111111111111111'>;
  }
  if (!accounts.rent.value) {
    accounts.rent.value =
      'SysvarRent111111111111111111111111111111111' as Address<'SysvarRent111111111111111111111111111111111'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('cpmmConfig', accounts.cpmmConfig),
      getAccountMeta('payer', accounts.payer),
      getAccountMeta('liquidityOwner', accounts.liquidityOwner),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('protocolFeeOwner', accounts.protocolFeeOwner),
      getAccountMeta('protocolFeePosition', accounts.protocolFeePosition),
      getAccountMeta('position', accounts.position),
      getAccountMeta('user0', accounts.user0),
      getAccountMeta('user1', accounts.user1),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('migrationAuthority', accounts.migrationAuthority),
      getAccountMeta('token0Program', accounts.token0Program),
      getAccountMeta('token1Program', accounts.token1Program),
      getAccountMeta('systemProgram', accounts.systemProgram),
      getAccountMeta('rent', accounts.rent),
      getAccountMeta('hookProgram', accounts.hookProgram),
    ],
    data: getCreateSpotPoolInstructionDataEncoder().encode(
      args as CreateSpotPoolInstructionDataArgs,
    ),
    programAddress,
  } as CreateSpotPoolInstruction<
    TProgramAddress,
    TAccountCpmmConfig,
    TAccountPayer,
    TAccountLiquidityOwner,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountPool,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountProtocolFeeOwner,
    TAccountProtocolFeePosition,
    TAccountPosition,
    TAccountUser0,
    TAccountUser1,
    TAccountCpmmProgram,
    TAccountMigrationAuthority,
    TAccountToken0Program,
    TAccountToken1Program,
    TAccountSystemProgram,
    TAccountRent,
    TAccountHookProgram
  >);
}

export type ParsedCreateSpotPoolInstruction<
  TProgram extends string = typeof CPMM_MIGRATOR_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    cpmmConfig: TAccountMetas[0];
    payer: TAccountMetas[1];
    liquidityOwner: TAccountMetas[2];
    token0Mint: TAccountMetas[3];
    token1Mint: TAccountMetas[4];
    pool: TAccountMetas[5];
    poolAuthority: TAccountMetas[6];
    poolVault0: TAccountMetas[7];
    poolVault1: TAccountMetas[8];
    protocolFeeOwner: TAccountMetas[9];
    protocolFeePosition: TAccountMetas[10];
    position: TAccountMetas[11];
    user0: TAccountMetas[12];
    user1: TAccountMetas[13];
    cpmmProgram: TAccountMetas[14];
    migrationAuthority: TAccountMetas[15];
    token0Program: TAccountMetas[16];
    token1Program: TAccountMetas[17];
    systemProgram: TAccountMetas[18];
    rent: TAccountMetas[19];
    /**
     * Omit it entirely for a hookless pool. When present it must equal
     * `args.hook_program`; CPMM additionally requires it to be executable.
     */
    hookProgram?: TAccountMetas[20] | undefined;
  };
  data: CreateSpotPoolInstructionData;
};

export function parseCreateSpotPoolInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedCreateSpotPoolInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 21) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 21,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  const getNextOptionalAccount = () => {
    const accountMeta = getNextAccount();
    return accountMeta.address === CPMM_MIGRATOR_PROGRAM_ADDRESS
      ? undefined
      : accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      cpmmConfig: getNextAccount(),
      payer: getNextAccount(),
      liquidityOwner: getNextAccount(),
      token0Mint: getNextAccount(),
      token1Mint: getNextAccount(),
      pool: getNextAccount(),
      poolAuthority: getNextAccount(),
      poolVault0: getNextAccount(),
      poolVault1: getNextAccount(),
      protocolFeeOwner: getNextAccount(),
      protocolFeePosition: getNextAccount(),
      position: getNextAccount(),
      user0: getNextAccount(),
      user1: getNextAccount(),
      cpmmProgram: getNextAccount(),
      migrationAuthority: getNextAccount(),
      token0Program: getNextAccount(),
      token1Program: getNextAccount(),
      systemProgram: getNextAccount(),
      rent: getNextAccount(),
      hookProgram: getNextOptionalAccount(),
    },
    data: getCreateSpotPoolInstructionDataDecoder().decode(instruction.data),
  };
}
